module.exports = __webpack_public_path__ + "static/img/design-3.6bf99657.png";